import cx from 'classnames';
import { blogsProfileUrl } from 'mk2/apps/blogs/urls';
import TesterPost from 'mk2/apps/testings/components/TesterPost';
import { Props } from 'mk2/apps/testings/containers/TestingDetail/TestingDetailPage';
import { RenderSnippetAs } from 'mk2/apps/wiki/utils';
import { AvatarImg } from 'mk2/components/AvatarImg';
import { Emojify } from 'mk2/components/Emojify';
import { Link } from 'mk2/components/Link';
import { LoadingSwitch } from 'mk2/containers/LoadingSwitch/LoadingSwitch';
import { astToHtml, defaultFilterAdditionalData, FilterAdditionalData } from 'mk2/helpers/article_ast/filters';
import { cacheLast } from 'mk2/helpers/cache';
import { dateLocal } from 'mk2/helpers/timeformat';
import { url } from 'mk2/helpers/urls';
import React from 'react';
import styles from './TestingDetail.mscss';

class TestingDetail extends React.Component<Props> {

    private astToHtmlCache = cacheLast(true);

    public render() {
        const { testing, loadingState } = this.props;
        return (
            <div className={styles.TestingDetail}>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderSuccess={this.renderSuccess}
                    hasData={!!testing}
                />
             </div>
        );
    }

    private renderSuccess = () => {
        const {testing, testersPosts, requestUserPermissions} = this.props;

         // prepare post message body
        let finishedText: React.ReactChild[] = null;

        if (testing.finishedText) {
            const additionalData: FilterAdditionalData = {
                ...defaultFilterAdditionalData,
                photos: testing.finishedTextProductTestingPhotos?.map((p) => p.photofile),
                customStyles: {
                    header2: styles.TestingDetail__body__content__header2,
                    header3: styles.TestingDetail__body__content__header3,
                    header4: styles.TestingDetail__body__content__header4,
                    paragraph: styles.TestingDetail__body__content__paragraph,
                    instagram: styles.TestingDetail__body__content__instagram,
                    tiktok: styles.TestingDetail__body__content__instagram,
                },
                linkedObjects: testing.finishedASTAdditionalData ? testing.finishedASTAdditionalData.linkedObjects : {},
                renderSpecialWikiLinks: false,
                renderLinksWithNofollow: false,
                renderSnippetObjectsAs: RenderSnippetAs.HTML_IFRAME,
            };
            finishedText = this.astToHtmlCache(() => astToHtml(testing.finishedText, additionalData), testing.finishedText);
        }

        return (
            <div>
                <div className={styles.TestingDetail__body}>
                    <h1 className={styles.TestingDetail__body__title}>
                        {testing.finishedTitle}
                    </h1>
                    <div className={styles.TestingDetail__body__meta}>
                        <Link to={url(blogsProfileUrl, {username: testing.user.username})}>
                            <AvatarImg
                                size={24}
                                user={testing.user}
                                className={styles.TestingDetail__body__meta__avatar}
                            />
                        </Link>
                        <Link
                            to={url(blogsProfileUrl, {username: testing.user.username})}
                            className={styles.TestingDetail__body__meta__author}
                        >
                            {testing.user.username}
                        </Link>
                        <span className={cx(styles.TestingDetail__body__meta__created, styles.TestingDetail__body__meta__sep)}>
                            {dateLocal(testing.updatedTime, false)}
                        </span>
                    </div>

                    <div className={styles.TestingDetail__body__content}>
                        <Emojify size={16}>
                            {finishedText}
                        </Emojify>
                    </div>
                </div>
                {testersPosts.length > 0 && testersPosts.map((post) => {
                    return (
                        <TesterPost
                            key={post.id}
                            post={post}
                            requestUserPermissions={requestUserPermissions}
                        />
                    );
                })}
            </div>
        );
    };

    private load = () => {
        const { onLoad, testingHashtag } = this.props;
        onLoad(testingHashtag);
    };
}

export default TestingDetail;
